import { noop } from 'lodash';
import React, { Component } from 'react';
import { filterToValidAttributes } from '@zocdoc-frontend-common/utils-dom-property';

/**
 * @param {string} groupBy
 * @param {function(): void} onChange
 * @param {Object[]} options
 * @param {string} placeholder
 * @param {string|number} selected
 * @returns {JSX.Element}
 */
export class Dropdown extends Component {
    static defaultProps = {
        groupBy: null,
        onChange: noop,
        options: [],
        selected: null,
    };

    render() {
        const { selected, placeholder, suppressPlaceholder, ...otherProps } =
            this.props;

        const thereIsPlaceholder = !!placeholder && !suppressPlaceholder;
        const thereIsNoSelectedOption = !selected;
        const minusOneIsSelected = selected === -1 || selected === '-1';
        const minusOneNotAvailableOnOptions = !otherProps.options.find(
            (o) => o.id === -1 || o.id === '-1'
        );

        const valueShouldBePlaceholder =
            thereIsPlaceholder &&
            (thereIsNoSelectedOption ||
                (minusOneIsSelected && minusOneNotAvailableOnOptions));

        const value = valueShouldBePlaceholder ? placeholder : selected;

        const placeholderOption = suppressPlaceholder ? null : (
            <option disabled value={placeholder}>
                {placeholder}
            </option>
        );

        const options = this.getOptions();

        const attributes = filterToValidAttributes(otherProps);

        return (
            <select
                data-test="select"
                data-uem-id="dropdown-select"
                tabIndex="0"
                {...attributes}
                value={value}
            >
                {placeholderOption}
                {options}
            </select>
        );
    }

    getOptionTag(option) {
        return (
            <option key={option.id} value={option.id}>
                {option.name}
            </option>
        );
    }

    getOptionTags(options) {
        return options.map((option) => this.getOptionTag(option));
    }

    getOptions() {
        const { options, groupBy } = this.props;

        if (groupBy) return this.getOptgroupTags(options);
        return this.getOptionTags(options);
    }

    getOptgroupTags(groups) {
        const { groupBy } = this.props;

        return groups.map((group) => {
            const children = this.getOptionTags(group[groupBy]);

            return (
                <optgroup key={group.id} label={group.name}>
                    {children}
                </optgroup>
            );
        });
    }
}
